// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-header {\r\n  background-color: #306d8a;\r\n  color: white;\n}\n.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {\r\n  color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
